import React from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import "react-table/react-table.css";
import 'bootstrap/dist/css/bootstrap.css';
import FontAwesome from 'react-fontawesome';
import { formatDate, getCommentIconForFieldWithCustomer, getCommentsForRowWithCustomer } from '../../Allocation/AllocationHelper';
import ReactTooltip from "react-tooltip";
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import { export2Excel } from '../../gridHelpers/gridHelpers'
import {Button} from 'react-bootstrap'

class AllocationDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state={
          header: this.props.apiToken ? {
              'Authorization': 'Bearer ' +  this.props.apiToken,
              'Accept': 'application/octet-stream'
          } : {},
          detailsGroups: this.props.data ? this.props.data : [], 
          expanded: {}, 
          page: 0,
          pageSize: 10, 
          resized: [],
          isLoading: false,
        };
        this.getColumns=this.getColumns.bind(this);
        this.getBody = this.getBody.bind(this);
        this.initializeView = this.initializeView.bind(this);
        this.getColumnColor = this.getColumnColor.bind(this);
        this.testGetColumns = this.testGetColumns.bind(this);
        this.testGetBody = this.testGetBody.bind(this);
        this.setProfileSessionStorage = this.setProfileSessionStorage.bind(this);
        this.initializeView();
      }     
      
      // För att fixa datum på kommentarer
      initializeView(){
        for(let i = 0; i < this.state.detailsGroups.length; i++){
          for(let j = 0; j < this.state.detailsGroups[i].Rows.length; j++){
            for(let k = 0; k < this.state.detailsGroups[i].Rows[j].Comments.length; k++){
              this.state.detailsGroups[i].Rows[j].Comments[k].Created = formatDate(this.state.detailsGroups[i].Rows[j].Comments[k]);
            }
          }
        }
        // if(this.state.detailsGroups.length > 0)
        //   this.setState({});
      }

      getColumnColor(row, key){
        if(row.RowType === "Diff (allocated - ordered)"){
          if(row[key] > 0)
            return {color: "green"}
          if(row[key] < 0)
            return {color: "red"}
        }
        return {};
      }

    componentDidUpdate(){
      ReactTooltip.rebuild();
    }

    setProfileSessionStorage(customerId) {
      window.sessionStorage.setItem("customerId", customerId);
      window.sessionStorage.setItem("allocationYear", this.props.selectedYear);
    }

    handleCustomerLink(viewMode){
      let returnObject = viewMode;
      if(viewMode != null && viewMode.includes("Customer")){
        let customerParts = viewMode.split(' ');
        let customerId = customerParts[customerParts.indexOf("Customer:")+1].replace(',','');
        if(customerId != null ||customerId != ''){
          returnObject = (<a href={`./customerprofile/${customerId}`} onClick={(event) => this.setProfileSessionStorage(customerId)}>{viewMode}</a>);
        }
      }
      return returnObject;
  }

    getColumns() {    
        return [          
          {            
            columns: [
              {
                minWidth:255,
                maxWidth:325,
                id:'ViewModes',
                className:'ViewModes',
                Cell: row => (
                  <div>
                    <span className="ViewModes">
                      {this.handleCustomerLink(row.original.ViewModes)}
                    </span>
                  </div>
                )
              },
              {
                width:125,
                id:'RowType',
                className:'RowType',
                Cell: row => {
                  let comments = getCommentsForRowWithCustomer(row.original);
                  return(
                  <div>
                    <span className="RowType flexSpan">
                      {row.original.RowType || ''}
                      {comments && 
                        <FontAwesome name="comments" data-for="globalTip" data-tip={comments}/>}
                    </span>
                  </div>
                )}
              },
            ]
          },
          {
            columns: [
              {
                Header: "Jan",
                maxWidth:90,
                id:'M1',
                className:'M1',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M1")} className="M1 flexSpan">
                      {row.original.GuiM1_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                  )
              },
              {
                Header: "Feb",
                maxWidth:90,
                id:'M2',
                className:'M2',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M2")} className="M2 flexSpan">
                      {row.original.GuiM2_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Mar",
                maxWidth:90,
                id:'M3',
                className:'M3',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M3")} className="M3 flexSpan">
                      {row.original.GuiM3_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Apr",
                maxWidth:90,
                id:'M4',
                className:'M4',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M4")} className="M4 flexSpan">
                      {row.original.GuiM4_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "May",
                maxWidth:90,
                id:'M5',
                className:'M5',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M5")} className="M5 flexSpan">
                      {row.original.GuiM5_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Jun",
                maxWidth:90,
                id:'M6',
                className:'M6',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M6")} className="M6 flexSpan">
                      {row.original.GuiM6_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Jul",
                maxWidth:90,
                id:'M7',
                className:'M7',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M7")} className="M7 flexSpan">
                      {row.original.GuiM7_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Aug",
                maxWidth:90,
                id:'M8',
                className:'M8',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M8")} className="M8 flexSpan">
                      {row.original.GuiM8_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Sep",
                maxWidth:90,
                id:'M9',
                className:'M9',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M9")} className="M9 flexSpan">
                      {row.original.GuiM9_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Oct",
                maxWidth:90,
                id:'M10',
                className:'M10',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M10")} className="M10 flexSpan">
                      {row.original.GuiM10_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Nov",
                maxWidth:90,
                id:'M11',
                className:'M11',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M11")} className="M11 flexSpan">
                      {row.original.GuiM11_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Dec",
                maxWidth:90,
                id:'M12',
                className:'M12',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "M12")} className="M12 flexSpan">
                      {row.original.GuiM12_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
              {
                Header: "Total",
                minWidth:110,
                id:'Total',
                className:'Total',
                Cell: row => (
                  <div>
                    <span style={this.getColumnColor(row.original, "Total")} className="Total flexSpan">
                        {row.original.GuiTotal_UC.toLocaleString('sv', {useGrouping:true}) || '0'}
                      {getCommentIconForFieldWithCustomer(row.column.id,row.original)}
                    </span>
                  </div>
                )
              },
            ]
          }
        ];
      }

      testGetColumns(){
        return [{columns:[{
                  // width:255,
                  id:'TestColumn',
                  className:'TestColumns',
                  Cell: row => (
                    <div>
                      <span className="ViewModes">
                        {row.original}
                      </span>
                    </div>
                  )
        }]}];
      }

      testGetBody(data){
        return(
          <div>
            <div>
                <NPReactTable
                className="margin-top-5 np-react-table"
                data={data}
                ref={(r) => { this.reactTable = r }}
                getTrProps={(state, rowInfo) => {
                  return {
                      }
                }}
                showPagination={true}
                showPageSizeOptions={true}
                hasHeaderGroups={false}
                sortable={false}
                minRows={5} 
                columns={this.testGetColumns()}
                defaultPageSize={10}
                // Controlled props
                sorted={this.state.sorted}
                page={this.state.page}
                pageSize={this.state.pageSize}
                expanded={this.state.expanded}
                resized={this.state.resized}  
                onResizedChange={resized => { this.setState({ resized }) } }
                onPageChange={
                  page => {
                    this.setState({ page, expanded: {} });
                  }
                }
                onPageSizeChange={(pageSize, page) => {
                    this.setState({ page, pageSize, expanded: {} });
                  }
                }
              />
            </div>
          </div>
        )
      }
      
    getBody(data){
      if (this.state.isLoading)
        {
          return (
              <LoadingSpinner isLoading={true} />
          );
        }
      else 
      {
        let body = [];
        data.forEach((d)=>{
            body.push(this.getTable(d.Rows));
        });
        let testBody = this.testGetBody(body);
        return(
            testBody
        );
      }
    }

    getTable(data){

        return(
            <div>
              <div>
                <Dialog ref={(el) => { this.dialog = el }} />   
                <ReactTooltip id="globalTip" html place="bottom" effect="solid"/>
                  <NPReactTable
                  
                  className="margin-top-5 np-react-table allocationTable"
                  data={data}
                  ref={(r) => { this.reactTable = r }}
                  showPagination={false}
                  showPageSizeOptions={false}
                  hasHeaderGroups={false}
                  sortable={false}
                  minRows={3} 
                  columns={this.getColumns()}
                  defaultPageSize={10000}
                  // Controlled props
                  // sorted={this.state.sorted}
                  // page={this.state.page}
                  // pageSize={this.state.pageSize}
                  // expanded={this.state.expanded}
                  // resized={this.state.resized}  
                  // onResizedChange={resized => { this.setState({ resized }) } }
                  // onPageChange={
                  //   page => {
                  //     this.setState({ page, expanded: {} });
                  //   }
                  // }
                  // onPageSizeChange={(pageSize, page) => {
                  //     this.setState({ page, pageSize, expanded: {} });
                  //   }
                  // }
                />
              </div>
            </div>
          )
    }

    render()
    {
        const data = this.state.detailsGroups ? this.state.detailsGroups : [];

        return ( 
            <div>  
                {this.getBody(data)}
            </div>
        );
    }
}

export default AllocationDetails;